var lists_default = {
  "fontElementMap": "IUejU",
  "orderedlist": "AyD42",
  "bulletedlist": "M95NH",
  "listItem": "Ixh5O"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
